/**
 Handles the creation of new records, when model.save() is called.
 If the bulk create option is passed to the adapter during save record is passed to the bulkManager, otherwise
 the super method of createRecord is called.

 Example
 ```
 model.save({ adapterOptions: { bulk: true } })
 ```
 @param {DS.Store} store
 @param {DS.Model} type the DS.Model class of the record
 @param {DS.Snapshot} snapshot
 @return {Promise} promise
 */
export function createRecordBulk(_store, _type, snapshot, bulkManager) {
  // the last line of the JSONApiSerializer.serialize() function will wrap the serialized model in a `data` key,
  // we are batching the create request hence the only `data` key in the payload should be the top level one e.g:
  //
  // {
  //   data: [serializedRecord, serializedRecord, ...]
  // }
  const { data } = snapshot.serialize()

  return bulkManager.callBulkAction.perform('POST', data)
}

/**
 Handles the updating of existing records, when model.save() is called.

 Example
 ```
 model.save({ adapterOptions: { bulk: true } })
 ```
 @param {DS.Store} store
 @param {DS.Model} type the DS.Model class of the record
 @param {DS.Snapshot} snapshot
 @return {Promise} promise
 */
export function updateRecordBulk(_store, _type, snapshot, bulkManager) {
  const { data } = snapshot.serialize()
  data.id = snapshot.id

  return bulkManager.callBulkAction.perform('PATCH', data)
}

export function deleteRecordBulk(_store, _type, snapshot, bulkManager) {
  // Build an object with id and model name
  const data = {
    id: snapshot.id,
    type: snapshot.modelName,
  }

  return bulkManager.callBulkAction.perform('DELETE', data, snapshot.adapterOptions?.additionalBulkData)
}
